import { View } from "./Invoices.view";

export const Container = () => {
  return <View />;
};
